'use client';

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  Sector,
} from 'recharts';

interface CapitalGraphProps {
  capitalStructure: {
    name: string;
    share: number;
  }[];
}

// A defined turquoise color chart
const COLORS = [
  '#00A5A0',
  '#2F8F9D',
  '#3BACB6',
  '#82DBD8',
  '#58FCEC',
  '#B3E8E5',
];

const CapitalGraph = ({ capitalStructure }: CapitalGraphProps) => {
  const data = capitalStructure.map(({ name, share }) => {
    return {
      name,
      value: share,
    };
  });

  return (
    <div className="relative size-full">
      <ResponsiveContainer className="absolute">
        <PieChart id="capital-graph">
          <Pie
            data={data}
            innerRadius={40}
            outerRadius={70}
            paddingAngle={2}
            dataKey="value"
            // eslint-disable-next-line react/no-unstable-nested-components, @typescript-eslint/no-explicit-any
            activeShape={(props: any) => {
              const {
                cx,
                cy,
                innerRadius,
                outerRadius,
                startAngle,
                endAngle,
                fill,
              } = props;

              return (
                <g>
                  <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                  />
                  <Sector
                    cx={cx}
                    cy={cy}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    innerRadius={outerRadius + 6}
                    outerRadius={outerRadius + 10}
                    fill={fill}
                  />
                </g>
              );
            }}
          >
            {data.map((entry, index) => (
              <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            // eslint-disable-next-line react/no-unstable-nested-components
            content={(el) => {
              if (el.active && el.payload?.length) {
                return (
                  <p className="rounded-xl border bg-primary-50 p-3">
                    {`${el.payload[0].name}: ${el.payload[0].value}%`}
                  </p>
                );
              }

              return null;
            }}
            wrapperStyle={{ padding: 0 }}
            itemStyle={{
              outline: 'hsl(var(--primary-100))',
            }}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CapitalGraph;
